// Copyright 2025-2026 Florian Gallon. All Rights reserved.
// Shared ingredient constants for RecipeManager, ProductManagement, and StockManagement

export const INGREDIENT_LIBRARY = [
  'breadFlour',
  'allPurposeFlour',
  'wholeWheatFlour',
  'ryeFlour',
  'water',
  'milk',
  'salt',
  'sugar',
  'activeDryYeast',
  'instantYeast',
  'sourdoughStarter',
  'poolish',
  'biga',
  'butter',
  'oliveOil',
  'eggs',
  'honey',
  'malt',
  'seeds',
  'nuts',
  'raisins',
  // Variation ingredients
  'chocolateBar',
  'almondCream',
  'slicedAlmonds',
  'cheese',
  'ham',
  'pecans',
  'walnuts',
  'cranberries',
  'olives',
  'sunDriedTomatoes'
];

export const INGREDIENT_TRANSLATIONS = {
  en: {
    breadFlour: 'Bread Flour',
    allPurposeFlour: 'All-Purpose Flour',
    wholeWheatFlour: 'Whole Wheat Flour',
    ryeFlour: 'Rye Flour',
    water: 'Water',
    milk: 'Milk',
    salt: 'Salt',
    sugar: 'Sugar',
    activeDryYeast: 'Active Dry Yeast',
    instantYeast: 'Instant Yeast',
    sourdoughStarter: 'Sourdough Starter',
    poolish: 'Poolish',
    biga: 'Biga',
    butter: 'Butter',
    oliveOil: 'Olive Oil',
    eggs: 'Eggs',
    honey: 'Honey',
    malt: 'Malt',
    seeds: 'Seeds',
    nuts: 'Nuts',
    raisins: 'Raisins',
    chocolateBar: 'Chocolate Bar',
    almondCream: 'Almond Cream',
    slicedAlmonds: 'Sliced Almonds',
    cheese: 'Cheese',
    ham: 'Ham',
    pecans: 'Pecans',
    walnuts: 'Walnuts',
    cranberries: 'Cranberries',
    olives: 'Olives',
    sunDriedTomatoes: 'Sun-Dried Tomatoes'
  },
  fr: {
    breadFlour: 'Farine à Pain',
    allPurposeFlour: 'Farine Tout Usage',
    wholeWheatFlour: 'Farine de Blé Entier',
    ryeFlour: 'Farine de Seigle',
    water: 'Eau',
    milk: 'Lait',
    salt: 'Sel',
    sugar: 'Sucre',
    activeDryYeast: 'Levure Sèche Active',
    instantYeast: 'Levure Instantanée',
    sourdoughStarter: 'Levain',
    poolish: 'Poolish',
    biga: 'Biga',
    butter: 'Beurre',
    oliveOil: 'Huile d\'Olive',
    eggs: 'Œufs',
    honey: 'Miel',
    malt: 'Malt',
    seeds: 'Graines',
    nuts: 'Noix',
    raisins: 'Raisins Secs',
    chocolateBar: 'Barre de Chocolat',
    almondCream: 'Crème d\'Amande',
    slicedAlmonds: 'Amandes Effilées',
    cheese: 'Fromage',
    ham: 'Jambon',
    pecans: 'Pacanes',
    walnuts: 'Noix de Grenoble',
    cranberries: 'Canneberges',
    olives: 'Olives',
    sunDriedTomatoes: 'Tomates Séchées'
  }
};